import React from 'react';
import { updateShowOtherUserProfileModal, showOtherUserRolesModal, showManageInvitationsModal } from 'actions/modal';
import {
  getUserProfileByUserId,
  updateSelectedUserInAllUsersPage,
  getUserRolesByUserId,
  getUserInvitationsByUserId,
  getUserCallsDetails,
} from 'actions/user';
import { displayGlobalMessage } from 'actions/globalMessage';
import { ContextualMenu } from 'components/shared/contextualMenu/content';
import { useDispatch } from 'react-redux';

const MeetingRoomUserActionsMenu = (props) => {
  const dispatch = useDispatch();
  const personId = props.selectedUser.personId;

  const showUserProfile = () => {
    if (props?.isAdmin) {
      dispatch(getUserCallsDetails(personId));
    }
    let cb = () => {
      dispatch(updateShowOtherUserProfileModal(true));
    };
    dispatch(getUserProfileByUserId(personId, cb));
  };

  const showOtherUserRoles = () => {
    dispatch(updateSelectedUserInAllUsersPage(props.selectedUser));
    let cb = () => {
      dispatch(showOtherUserRolesModal(true));
    };
    dispatch(getUserRolesByUserId(personId, cb));
  };

  const showUserInvitation = () => {
    dispatch(updateSelectedUserInAllUsersPage(props.selectedUser));
    let cb = (openOrNot) => {
      dispatch(showManageInvitationsModal(openOrNot));
    };
    dispatch(getUserInvitationsByUserId(personId, cb));
  };

  const emailUser = () => {
    const mailToLink = 'mailto:' + props.selectedUser.email;
    window.location.href = mailToLink;

    const successMessage = APP.LANGUAGE.ManageAllUsers.EmailAllUsersSuccessMessage;
    dispatch(
      displayGlobalMessage({
        text: successMessage,
        visible: true,
        messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
        autoHide: true,
      })
    );
  };

  if (!!props.selectedUser) {
    return (
      <ContextualMenu
        id={props.selectedUser.id}
        options={[
          // For registered users
          {
            title: APP.LANGUAGE.ManageAllUsers.ViewProfile,
            customAction: false,
            show: props.selectedUser.firstName != null && props.selectedUser.lastName != null,
            action: () => showUserProfile(),
          },
          {
            title: APP.LANGUAGE.ManageAllUsers.ManageRoles,
            customAction: false,
            show: props.selectedUser.firstName != null && props.selectedUser.lastName != null,
            action: () => showOtherUserRoles(),
          },
          {
            title: APP.LANGUAGE.ManageAllUsers.EmailUser,
            customAction: false,
            show: props.selectedUser.firstName != null && props.selectedUser.lastName != null,
            action: () => emailUser(),
          },
          // For invited users
          {
            title: APP.LANGUAGE.ManageAllUsers.ManageInvitations,
            customAction: false,
            show: props.selectedUser.firstName == null && props.selectedUser.lastName == null,
            action: () => showUserInvitation(),
          },
        ]}
      />
    );
  } else return '';
};

export default MeetingRoomUserActionsMenu;
